import { render, staticRenderFns } from "./chooseMember.vue?vue&type=template&id=1215245d"
import script from "./chooseMember.vue?vue&type=script&lang=js"
export * from "./chooseMember.vue?vue&type=script&lang=js"
import style0 from "./chooseMember.vue?vue&type=style&index=0&id=1215245d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports